export default __webpack_public_path__ + "static/media/icon-reprovado.da8661bc.svg";